function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Return({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.68 18.89l.002-.057a1.004 1.004 0 01-.26.673l-2.611 2.869a.996.996 0 01-1.412.066.998.998 0 01-.067-1.412l1.088-1.197H4c-1.654 0-3-1.345-3-3v-3.99a1 1 0 112 0v3.99c0 .553.45 1 1 1h15.48l-1.148-1.263a.998.998 0 01.067-1.412.998.998 0 011.412.066l2.61 2.87c.184.2.27.455.26.706l.001.034v.012l-.001.044zM5.286 1.26a1 1 0 01.067 1.412l-1.09 1.195 15.42.001c1.654 0 3 1.345 3 3v3.99a1 1 0 11-2 0V6.87c0-.552-.449-1-1-1H4.2l1.15 1.264a1 1 0 11-1.478 1.346L1.26 5.609A.996.996 0 011 4.903v-.046l.001-.04v.052a1.004 1.004 0 01.26-.673l2.61-2.869a1 1 0 011.414-.066z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoReturn = React.memo(Return);
export default MemoReturn;